import Vue from 'vue';
import Vuex from 'vuex';
import { auth } from '#/modules/auth.module';
import { alert } from '#/modules/alert.module';
import { brand } from '#/modules/brand.module';
import { user } from '#/modules/user.module';
import { car } from '#/modules/car.module';
import { modal } from '#/modules/modal.module';
import { myCars } from '#/modules/mycars.module';
import { serviceStations } from '#/modules/servicestations.module';
import { carServices } from '#/modules/carservices.module';
import { visit } from '#/modules/visit.module';
import { geolocation } from '#/modules/geolocation.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    alert,
    brand,
    user,
    car,
    modal,
    myCars,
    serviceStations,
    carServices,
    visit,
    geolocation,
  },
});
